<script>
  import { fade } from "svelte/transition";
  export let videoid;
  export let image;
  export let play;
  export let title;
</script>

<img src={image} out:fade class="image" loading="lazy" alt={title} />
<svg
  on:click={play(videoid)}
  class="play-icon"
  out:fade
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="white"
>
  <path
    fill-rule="evenodd"
    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
    clip-rule="evenodd"
  />
</svg>

<style>
  .image {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: contain;
    pointer-events: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-touch-callout: none;
  }
  .play-icon {
    width: 20%;
    height: 20%;
    position: absolute;
  }

  .play-icon:active {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: 0;
    fill: yellowgreen;
  }

  @media screen and (orientation: portrait) {
    .image {
      object-fit: contain;
    }
  }
  /* landscape */
  @media screen and (orientation: landscape) {
    /* landscape-specific styles */
  }
</style>
